import { render } from "./AtomLegend.vue?vue&type=template&id=66ebc34a&scoped=true&ts=true"
import script from "./AtomLegend.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomLegend.vue?vue&type=script&lang=ts&setup=true"

import "./AtomLegend.vue?vue&type=style&index=0&id=66ebc34a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ebc34a"],['__file',"src/components/atoms/AtomLegend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66ebc34a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66ebc34a', __exports__)) {
    api.reload('66ebc34a', __exports__)
  }
  
  module.hot.accept("./AtomLegend.vue?vue&type=template&id=66ebc34a&scoped=true&ts=true", () => {
    api.rerender('66ebc34a', render)
  })

}


export default __exports__